import { ChangeEvent } from 'react'

// Callback to make inputs only uppercase and remove non-alphanumeric characters
export const makeInputUppercaseAndRemoveNonAlphanumeric = (e: ChangeEvent<HTMLInputElement>) => {
    // Grrr, deal with making things uppercase and remove non-alphanumeric characters
    // Annoying to have to deal with selection range, but it's the only way to do it
    // without messing with the cursor position
    const input = e.target
    const start = input.selectionStart
    const end = input.selectionEnd
    const transformedValue = input.value.replace(/[^a-z0-9]/gi, '').toUpperCase()
    input.value = transformedValue
    input.setSelectionRange(start, end)
}
